//
import * as yup from 'yup'
import { PoolBaseAccountCTO, PoolBaseAccountCTOSchema } from './PoolBaseAccountCTO'
import { PoolBaseOverviewCTO, PoolBaseOverviewCTOSchema } from './PoolBaseCTO'
import { PoolDynamicAccountCTO, PoolDynamicAccountCTOSchema } from './PoolDynamicAccountCTO'
import { PoolDynamicOverviewCTO, PoolDynamicOverviewCTOSchema } from './PoolDynamicCTO'
import { PoolAccountAccessPairCTOSchema } from './PoolAccountAccessPairCTO'

import { PoolLytAccountCTO, PoolLytAccountCTOSchema } from './PoolLytAccountCTO'
import { PoolLytOverviewCTO, PoolLytOverviewCTOSchema } from './PoolLytOverviewCTO'
import {
  DynamicWithdrawalActivityCTO,
  DynamicWithdrawalActivityCTOSchema,
  PoolEventCTO,
  PoolEventSchema,
  WithdrawalActivityCTO,
  WithdrawalActivityCTOSchema,
} from './PoolEventCTO'
import {
  PoolFlexAccountCTO,
  PoolFlexAccountCTOSchema,
  PoolFlexAccountSummaryCTO,
  PoolFlexAccountSummaryCTOSchema,
} from './PoolFlexAccountCTO'
import { PoolFlexOverviewCTO, PoolFlexOverviewCTOSchema } from './PoolFlexCTO'
import {
  PoolAccountCTO,
  PoolAccountSummaryCTO,
  PoolTermAccountCTOSchema,
  PoolTermAccountSummaryCTOSchema,
} from './PoolTermAccountCTO'
import { poolIsOpenForInvestment, PoolOverviewCTO, PoolOverviewCTOSchema, PoolSummaryDTO } from './PoolTermCTO'

import { ContractCTO } from './ContractCTO'
import { LiquidityAsset } from './LiquidityAsset'
import { PoolOffchainDataReportingSchema } from './PoolOffchainDataCTO'
import { EventNameForTemplate, EventTypeForTemplate, PoolEventEmailStatus } from './templateApx'
import { TemplateDataObject } from './TemplateDataObject'

export {
  PoolAccountAccessPairCTOSchema,
  DynamicWithdrawalActivityCTOSchema,
  PoolBaseAccountCTOSchema,
  PoolBaseOverviewCTOSchema,
  PoolDynamicAccountCTOSchema,
  PoolDynamicOverviewCTOSchema,
  PoolLytAccountCTOSchema,
  PoolLytOverviewCTOSchema,
  PoolEventSchema,
  PoolFlexAccountCTOSchema,
  PoolFlexAccountSummaryCTOSchema,
  PoolFlexOverviewCTOSchema,
  poolIsOpenForInvestment,
  PoolOffchainDataReportingSchema,
  PoolOverviewCTOSchema,
  PoolTermAccountCTOSchema,
  PoolTermAccountSummaryCTOSchema,
  WithdrawalActivityCTOSchema,
  EventTypeForTemplate,
  PoolEventEmailStatus,
}
export type {
  ContractCTO,
  DynamicWithdrawalActivityCTO,
  EventNameForTemplate,
  LiquidityAsset,
  PoolAccountCTO,
  PoolAccountSummaryCTO,
  PoolBaseAccountCTO,
  PoolBaseOverviewCTO,
  PoolDynamicAccountCTO,
  PoolDynamicOverviewCTO,
  PoolEventCTO,
  PoolFlexAccountCTO,
  PoolFlexAccountSummaryCTO,
  PoolFlexOverviewCTO,
  PoolLytAccountCTO,
  PoolLytOverviewCTO,
  PoolOverviewCTO,
  PoolSummaryDTO,
  TemplateDataObject,
  WithdrawalActivityCTO,
}

export const PoolReportingAccountCTOSchema = () => {
  return yup.object({})
}

export const PoolLenderReportingAccountFlexCTOSchema = () => {
  return yup.object({})
}

export const PoolOffchainDataLenderReportingSchema = () => {
  return yup.object({})
}

export const PoolLenderReportingAccountCTOSchema = () => {
  return yup.object({})
}

export const PoolLenderReportingAccountDynamicCTOSchema = () => {
  return yup.object({})
}
